import { IUser } from "@typed/User";

import { useSyncExternalStore } from "react";
import { Store } from "nanostores";
import { getUserStore } from "./gacUserStore";

export function useNanostore<T>(store: Store<T>, getServerSnapshot: () => T): T {
  // `subscribe` must call listener when the store updates
  // `getServerSnapshot` is required so React knows what to render during SSR/hydration
  return useSyncExternalStore(store.listen, store.get, getServerSnapshot);
}

export function useGacUser(): IUser | null {
  return useNanostore(getUserStore(), () => null);
}
